function ready_submit(checkbox_agree, submit_button, email_value) {
    let empty_email = email_value.value == null || email_value.value == '';
    let ok = checkbox_agree.checked && !empty_email;
    submit_notice = document.querySelector('#submit-notice');
    if (submit_notice) {
        if (!checkbox_agree.checked) {
            submit_notice.innerText = '文頭のチェックボックス（□）を押して、同意の意思表示をお願いします';
        } else {
            submit_notice.innerText = empty_email ? '上にあるE-mail欄にEメールの送り先を記入してください' : '';
        }
    }
    submit_button.disabled = !ok
}

function peek_agree() {
    let checkbox_agree = document.querySelector('#i-agree');
    if (checkbox_agree == null) return;
    let submit_button = document.querySelector('#submit-button');
    if (submit_button == null) return;
    let email_value = document.querySelector('#email-value');
    if (email_value == null) return;
    email_value.addEventListener('input', ()=>{
        ready_submit(checkbox_agree, submit_button, email_value);
    });
    checkbox_agree.addEventListener('click', ()=>{
        ready_submit(checkbox_agree, submit_button, email_value);
    });
    ready_submit(checkbox_agree, submit_button, email_value);
}

peek_agree();